export const iconFontAwesomeSecurityFileContract = (
	<i className="fa-solid fa-file-contract"></i>
);
